<template>
  <ModalV2
    title="Das werden Sie verpassen"
    :close-icon="icons.close"
    :visible="visible"
    @close="close"
  >
    <template #body>
      <div class="flex-container w-100 align-center text-center">
        <img
          alt="An image"
          class="mbs flex-container align-center row"
          :src="icons.commonLargeCancel"
        />
      </div>
      <div class="flex-container align-center">
        <div class="flex-dir-column">
          <div
            v-for="(pointCopy, index) in unPrettierNuggets.getPoints(
              subscription,
            )"
            :key="index"
            class="mts mbm column pll"
          >
            <img alt="An image" class="mrs" :src="icons.commonSmallCheckBlue" />
            <span class="text-medium text-black" v-html="pointCopy"></span>
          </div>
          <p class="text-small text-center">
            {{ unPrettierNuggets.ifYouCancelCopy(subscription) }}
          </p>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="row align-center">
        <div class="column shrink">
          <button class="mbn button tiny secondary hollow" @click="next">
            Weiter Abbrechen
          </button>
        </div>
        <div class="column shrink">
          <button
            type="button"
            class="button tiny mbn prm plm text-small"
            @click="close"
          >
            Premium behalten
          </button>
        </div>
      </div>
    </template>
  </ModalV2>
</template>

<script>
import ModalV2 from '../../../../shared/Modal/ModalV2.vue';

export default {
  components: {
    ModalV2,
  },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unPrettierNuggets: {
        getPoints: (subscription) => {
          const socialMediaBlock = [
            `<strong>150,000+</strong> Social-Media-Vorlagen und Designtools`,
            `<strong>10,000+</strong> Visitenkartenvorlagen und Designtools`,
            `<strong>40,000+</strong> Poster-, Flyer-, Briefkopfvorlagen und mehr`,
          ];
          const perpStorAndPremium = [
            `Dauerhafte Speicherung Ihrer Dateien`,
            `Premium-Vorlagen`,
          ];
          const website = [
            `<strong>Mobile-friendly Website</strong> mit Ihrem Logo`,
          ];
          switch (subscription.subscriptionType) {
            case 'WebHosting':
              return [
                `Professionell gestaltete Website`,
                `Bearbeitbare Site über WordPress CMS`,
                `Domänenname`,
                `Hosting`,
                `Mit Ihrem Logo individualisierte Website`,
              ];
            case 'LogoEditor':
              break;
            case 'SocialMediaEditor':
              break;
            case 'VipCustomerService':
              return [
                `Spezielles 24/7-VIP-Telefon und Anrufe zur gemeinsamen Bildschirmnutzung`,
                `Alle Ihre E-Mails befinden sich ganz oben in einer dedizierten Warteschlange`,
                `Erhalten Sie Premium-Support für alle Ihre Fragen`,
                `Unser Team kann Ihnen bei der Kommunikation mit den Designern helfen, um das perfekte Design für Sie zu erhalten`,
              ];
            case 'PerpetualStorage':
              return [
                `Dauerhafte Speicherung Ihrer Designdateien auf DesignCrowd`,
              ];
            case 'ProDesignerSupport':
              break;
            case 'SocialMediaDesign':
              return [
                `Social-Media-Designs werden monatlich von unseren Designern für Sie erstellt`,
                `Benutzerdefinierte Facebook- und Instagram-Designs`,
                `Industriestandarddateien`,
                `E-Mail-Support rund um die Uhr`,
                `Bearbeitungszeit: 2 Tage`,
              ];
            case 'PremiumDesignPack':
              return [
                `<strong>Logo editor</strong> mit unbegrenzten Bearbeitungen und Downloads`,
                ...socialMediaBlock,
                ...perpStorAndPremium,
              ];
            case 'LogoAndMorePackage1':
              return [...socialMediaBlock, ...perpStorAndPremium];
            case 'LogoAndMorePackage2':
              return [...website, ...socialMediaBlock, ...perpStorAndPremium];
            case 'LogoAndMorePackage3':
              return [
                `<strong>Von unseren Designern erstellte und für Sie erstellte Social-Media-Designs</strong>`,
                ...website,
                ...socialMediaBlock,
                ...perpStorAndPremium,
              ];
            default:
              break;
          }

          return [];
        },
        ifYouCancelCopy: (subscription) => {
          return `Wenn Sie Ihr Abonnement nach ${subscription.renewalDateCopy} kündigen, verlieren Sie alle Ihre Premium-Vorteile`;
        },
      },
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    next() {
      this.$emit('next');
    },
  },
};
</script>
